import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
    EditEvidenceFormValues,
    EditEvidenceFormValidationSchema,
    defaultEditEvidenceFormValues,
} from "./EditEvidenceFormValues";
import FormDateInput from "../FormDateInput";
import Button from "../Button";

type EditEvidenceFormProps = {
    onSubmit: (values: EditEvidenceFormValues) => void;
    onCancel: () => void;
    initialValues?: EditEvidenceFormValues;
    isLoading: boolean;
};

const EditEvidenceForm = ({
    onSubmit,
    onCancel,
    initialValues = defaultEditEvidenceFormValues,
    isLoading,
}: EditEvidenceFormProps) => {
    const methods = useForm<EditEvidenceFormValues>({
        mode: "onSubmit",
        resolver: yupResolver(EditEvidenceFormValidationSchema),
        defaultValues: initialValues,
    });

    const validFromDate = methods.watch("validFromDate");
    const validToDate = methods.watch("validToDate");

    return (
        <form onSubmit={methods.handleSubmit(onSubmit)} className="space-y-4">
            <div className="grid grid-cols-2 gap-6">
                <Controller
                    name="validFromDate"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                        <FormDateInput
                            required
                            id="valid-from-date"
                            label="Valid from"
                            helperText="DD/MM/YYYY"
                            onChange={onChange}
                            value={value}
                            maxDate={validToDate ?? undefined}
                            error={methods.formState.errors.validFromDate}
                        />
                    )}
                />
                <Controller
                    name="validToDate"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                        <FormDateInput
                            required
                            id="valid-to-date"
                            label="Valid to"
                            helperText="DD/MM/YYYY"
                            onChange={onChange}
                            value={value}
                            minDate={validFromDate ?? undefined}
                            error={methods.formState.errors.validToDate}
                        />
                    )}
                />
            </div>
            <div className="flex justify-end gap-4 pt-7">
                <Button
                    variant="transparent"
                    type="button"
                    disabled={isLoading}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button loading={isLoading}>Update</Button>
            </div>
        </form>
    );
};

export default EditEvidenceForm;
